import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import mixpanel from "mixpanel-browser";
import ReactPWAInstallProvider from "./Components/PwaInstall";
import CssBaseline from "@material-ui/core/CssBaseline";
import { ThemeProvider as StyledThemeProvider } from "styled-components";
import {
  ThemeProvider as MaterialThemeProvider,
  createMuiTheme,
} from "@material-ui/core";
import { Offline, Online } from "react-detect-offline";

import "./Services/Zendesk";
import "./index.css";
import App from "./App";
import Store from "./Store";
import OfflineSplash from "./Components/OfflineSplash";
import reportWebVitals from "./reportWebVitals";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
/* import { initializeFirebase } from "./Services/Firebase"; */

const theme = {
  foreground: "#000000",
  background: "#eeeeee",
  containerBackground: "#f4f4f4",
  typography: {
    fontSize: 14,
    fontFamily: "Montserrat Alternates",
  },
  palette: {
    primary: {
      main: "#2dad67",
      contrastText: "#fff",
    },
    secondary: {
      main: "#ffa500",
      contrastText: "#fff",
    },
    text: {
      primary: "#373737",
    },
    divider: "#eee",
  },
  overrides: {
    MuiButton: {
      root: {
        minWidth: "30px",
        textAlign: "center",
      },
    },
    MuiTabs: {
      indicator: {
        backgroundColor: "orange",
      },
    },
  },
};
const materialTheme = createMuiTheme(theme);

mixpanel.init("e7411108b322b361cdb666ee836ca0f8");

ReactDOM.render(
  <Provider store={Store}>
    <CssBaseline />
    <StyledThemeProvider theme={theme}>
      <MaterialThemeProvider theme={materialTheme}>
        <ReactPWAInstallProvider>
          <App className="app" />
          <Offline polling={false}>
            <OfflineSplash />
          </Offline>
        </ReactPWAInstallProvider>
      </MaterialThemeProvider>
    </StyledThemeProvider>
  </Provider>,
  document.getElementById("root")
);
/* initializeFirebase(); */
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
